import React from "react";
// import moment from 'moment';
import { Route, Routes, useNavigate } from "react-router-dom";
import {
  Dashboard,
  Home,
  Login,
  MusicPlayer,
  UserProfile,
  Contact,
} from "./components";
import { useState, useEffect } from "react";
import { app } from "./config/Firebase.config";

import { getAuth } from "firebase/auth";
import { AnimatePresence, animate } from "framer-motion";
import { validateUser } from "./Api";
import { useStateValue } from "./Context/StateProvider";
import { actionType } from "./Context/reducer";
import { motion } from "framer-motion";
const App = () => {
  const firebaseAuth = getAuth(app);
  const navigate = useNavigate();

  const [{ user, isSongPlaying }, dispatch] = useStateValue();
  const [auth, setAuth] = useState(
    false || window.localStorage.getItem("auth") === "true"
  );

  useEffect(() => {
    firebaseAuth.onAuthStateChanged((userCred) => {
      if (userCred) {
        userCred.getIdToken().then((token) => {
          //console.log(token);
          validateUser(token).then((data) => {
            dispatch({
              type: actionType.SET_USER,
              user: data,
            });
          });
        });
      } else {
        setAuth(false);
        window.localStorage.setItem(auth, "false");
        dispatch({
          type: actionType.SET_USER,
          user: null,
        });
        navigate("/login");
      }
    });
  }, []);

  return (
    <AnimatePresence>
      <div className=" h-auto min-w-[680px] bg-primary flex  justify-center items-center ">
        <Routes>
          <Route path="/login" element={<Login setAuth={setAuth} />} />
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/UserProfile" element={<UserProfile />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        {isSongPlaying && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            className={`fixed min-w-[720px] h-25 insert-x-0 bottom-0  bg-cardOverlay backdrop-blur-md flex items-center justify-center`}
          >
            <MusicPlayer />
          </motion.div>
        )}
      </div>
    </AnimatePresence>
  );
};

export default App;
